<template>
  <div
    v-bind:class="[
      displayMode == 0
        ? 'base_container summary_grid item_container_margin'
        : 'container_module_type summary_grid',
    ]"
  >
    <div v-if="displayMode == 0" class="summary_top">
      <div class="summary_text summary_text_weight_700">{{ titleText }}</div>
      <div class="summary_menu_container">
        <RecycleTypeChartLegend />
      </div>
    </div>
    <div
      v-else
      style="
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        padding-top: 10px;
      "
    >
      <div />
      <div
        class="summary_text summary_text_weight_700"
        style="align-items: center"
      >
        {{ titleText }}
      </div>
      <div class="summary_menu_container">
        <RecycleTypeChartLegend />
      </div>
    </div>
    <div v-if="dataCount > 0">
      <div class="bottom_container_total_chart">
        <div
          v-bind:class="[
            displayMode == 0
              ? 'total_chart_value_text value_text_margin_standalone'
              : 'total_chart_value_text value_text_margin_module',
          ]"
        >
          {{ convertToFormattedNumber(totalAmount) }}{{ unitText }}
        </div>
        <div
          style="
            width: 100%;
            height: 135px;
            display: inline-flex;
            box-sizing: border-box;
          "
        >
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="simpleReuseWidth"
            v-bind:adjustedWidth="getWidth(simpleReuseWidth)"
            v-bind:itemPercentage="simpleReusePercentage"
            v-bind:itemText="simpleReuseText"
            v-bind:itemTotal="simpleReuseTotal"
            itemColor="#237e9d"
            marginLeftPixel="'0px'"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="creativeWidth"
            v-bind:adjustedWidth="getWidth(creativeWidth)"
            v-bind:itemPercentage="creativePercentage"
            v-bind:itemText="creativeText"
            v-bind:itemTotal="creativeTotal"
            itemColor="#6bdbd1"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="recycleWidth"
            v-bind:adjustedWidth="getWidth(recycleWidth)"
            v-bind:itemPercentage="recyclePercentage"
            v-bind:itemText="recycleText"
            v-bind:itemTotal="recycleTotal"
            itemColor="#6558d3"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="chemicalRecycleWidth"
            v-bind:adjustedWidth="getWidth(chemicalRecycleWidth)"
            v-bind:itemPercentage="chemicalRecyclePercentage"
            v-bind:itemText="chemicalRecycleText"
            v-bind:itemTotal="chemicalRecycleTotal"
            itemColor="#4DB8AD"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="materialRecycleWidth"
            v-bind:adjustedWidth="getWidth(materialRecycleWidth)"
            v-bind:itemPercentage="materialRecyclePercentage"
            v-bind:itemText="materialRecycleText"
            v-bind:itemTotal="materialRecycleTotal"
            itemColor="#4db280"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="thermalRecycleWidth"
            v-bind:adjustedWidth="getWidth(thermalRecycleWidth)"
            v-bind:itemPercentage="thermalRecyclePercentage"
            v-bind:itemText="thermalRecycleText"
            v-bind:itemTotal="thermalRecycleTotal"
            itemColor="#f8735d"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="afterIncinerationRecycleWidth"
            v-bind:adjustedWidth="getWidth(afterIncinerationRecycleWidth)"
            v-bind:itemPercentage="afterIncinerationRecyclePercentage"
            v-bind:itemText="afterIncinerationRecycleText"
            v-bind:itemTotal="afterIncinerationRecycleTotal"
            itemColor="#CD87DC"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="incinerationWidth"
            v-bind:adjustedWidth="getWidth(incinerationWidth)"
            v-bind:itemPercentage="incinerationPercentage"
            v-bind:itemText="incinerationText"
            v-bind:itemTotal="incinerationTotal"
            itemColor="#f0a6ce"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="landfillWidth"
            v-bind:adjustedWidth="getWidth(landfillWidth)"
            v-bind:itemPercentage="landfillPercentage"
            v-bind:itemText="landfillText"
            v-bind:itemTotal="landfillTotal"
            itemColor="#f4b852"
          />
        </div>
      </div>
    </div>
    <div v-else style="height: 220px">
      <DataNotFound />
    </div>
  </div>
</template>

<script>
import utils from '../../mixins/utils'
import RecycleTypeChartBar from './RecycleTypeChartBar'
import RecycleTypeChartLegend from './RecycleTypeChartLegend'
import DataNotFound from '../common/DataNotFound'

export default {
  name: 'RecycleTypeChart',
  components: { RecycleTypeChartBar, RecycleTypeChartLegend, DataNotFound },
  props: {
    receivedData: {
      type: Object,
      default: () => {}
    },
    titleText: {
      type: String,
      default: 'リサイクルタイプ (選別後）'
    },
    displayMode: {
      type: Number,
      default: 0
    }
  },
  mixins: [utils],
  watch: {
    receivedData: function() {
      this.refreshChart()
    }
  },
  data() {
    return {
      unitText: 't',
      simpleReuseText: '単純リユース',
      creativeText: 'クリエイティブ',
      recycleText: 'リサイクル',
      chemicalRecycleText: 'ケミカルリサイクル',
      materialRecycleText: 'マテリアルリサイクル',
      thermalRecycleText: 'サーマルリサイクル',
      afterIncinerationRecycleText: '焼却後リサイクル',
      incinerationText: '単純焼却',
      landfillText: '埋立',
      totalAmount: 1872.7,
      simpleReuseWidth: 20,
      creativeWidth: 20,
      recycleWidth: 20,
      chemicalRecycleWidth: 20,
      thermalRecycleWidth: 20,
      afterIncinerationRecycleWidth: 20,
      incinerationWidth: 20,
      materialRecycleWidth: 20,
      landfillWidth: 20,
      simpleReusePercentage: 0.0,
      creativePercentage: 0.0,
      recyclePercentage: 0.0,
      chemicalRecyclePercentage: 0.0,
      materialRecyclePercentage: 0.0,
      thermalRecyclePercentage: 0.0,
      afterIncinerationRecyclePercentage: 0.0,
      incinerationPercentage: 0.0,
      landfillPercentage: 0.0,
      incinerationTotal: 0,
      recycleTotal: 0,
      chemicalRecycleTotal: 0,
      materialRecycleTotal: 0,
      thermalRecycleTotal: 0,
      afterIncinerationRecycleTotal: 0,
      landfillTotal: 0,
      creativeTotal: 0,
      simpleReuseTotal: 0,
      dataCount: 0,
    }
  },
  mounted() {
    this.dataCount = Object.keys(this.receivedData).length
    if(this.dataCount > 0) {
      this.refreshChart()
    }
  },
  methods: {
    refreshChart() {
      if (!this.receivedData) return
      this.dataCount = Object.keys(this.receivedData).length
      this.incinerationTotal = this.getTotal(this.receivedData.Incineration)
      this.chemicalRecycleTotal = this.getTotal(this.receivedData.ChemicalRecycle)
      this.materialRecycleTotal = this.getTotal(this.receivedData.MaterialRecycle)
      this.thermalRecycleTotal = this.getTotal(this.receivedData.ThermalRecycle)
      this.afterIncinerationRecycleTotal = this.getTotal(this.receivedData.AfterIncinerationRecycle)
      this.landfillTotal = this.getTotal(this.receivedData.Landfill)
      this.recycleTotal = this.getTotal(this.receivedData.Recycle)
      this.creativeTotal = this.getTotal(this.receivedData.CreativeReuse)
      this.simpleReuseTotal = this.getTotal(this.receivedData.SimpleReuse)

      this.totalAmount = this.incinerationTotal + this.chemicalRecycleTotal + this.materialRecycleTotal
              + this.thermalRecycleTotal + this.afterIncinerationRecycleTotal+ this.landfillTotal + this.creativeTotal 
              + this.simpleReuseTotal + this.recycleTotal

      this.simpleReusePercentage = this.simpleReuseTotal / this.totalAmount * 100
      this.creativePercentage = this.creativeTotal / this.totalAmount * 100
      this.recyclePercentage = this.recycleTotal / this.totalAmount * 100
      this.chemicalRecyclePercentage = this.chemicalRecycleTotal / this.totalAmount * 100
      this.materialRecyclePercentage = this.materialRecycleTotal / this.totalAmount * 100
      this.thermalRecyclePercentage = this.thermalRecycleTotal / this.totalAmount * 100
      this.afterIncinerationRecyclePercentage = this.afterIncinerationRecycleTotal / this.totalAmount * 100
      this.incinerationPercentage = this.incinerationTotal / this.totalAmount * 100
      this.landfillPercentage = this.landfillTotal / this.totalAmount * 100

      if(this.totalAmount < 1000.0) {
        this.unitText = "kg"
      } else {
        this.totalAmount = this.totalAmount / 1000
        this.incinerationTotal = this.incinerationTotal / 1000
        this.chemicalRecycleTotal = this.chemicalRecycleTotal / 1000
        this.materialRecycleTotal = this.materialRecycleTotal / 1000
        this.thermalRecycleTotal = this.thermalRecycleTotal / 1000
        this.afterIncinerationRecycleTotal = this.afterIncinerationRecycleTotal / 1000
        this.recycleTotal = this.recycleTotal / 1000
        this.landfillTotal = this.landfillTotal / 1000
        this.creativeTotal = this.creativeTotal / 1000
        this.simpleReuseTotal = this.simpleReuseTotal / 1000
        this.unitText = "t"
      }

      this.simpleReuseWidth = this.getAdjustedWidth(this.simpleReusePercentage)
      this.creativeWidth = this.getAdjustedWidth(this.creativePercentage)
      this.recycleWidth = this.getAdjustedWidth(this.recyclePercentage)
      this.chemicalRecycleWidth = this.getAdjustedWidth(this.chemicalRecyclePercentage)
      this.materialRecycleWidth = this.getAdjustedWidth(this.materialRecyclePercentage)
      this.thermalRecycleWidth = this.getAdjustedWidth(this.thermalRecyclePercentage)
      this.afterIncinerationRecycleWidth = this.getAdjustedWidth(this.afterIncinerationRecyclePercentage)
      this.incinerationWidth = this.getAdjustedWidth(this.incinerationPercentage)
      this.landfillWidth = this.getAdjustedWidth(this.landfillPercentage)

      this.redrawChart()
    },
    getTotal(jsonObject) {
      if(jsonObject == null) {
        return 0
      }
      let total = 0
      for (var item in jsonObject) {
        total += jsonObject[item] / 1000 // gram to kg
      }
      return total
    },
    getWidth(value) {
      if(value <= 5) { // 今のところ、最低限のスペース
        return '5%'
      }
      return value + '%'
    },
    getAdjustedWidth(widthValue) {
      if(widthValue <= 0) {
        return 0
      }
      if(widthValue < 5) {
        return 5
      }
      return widthValue
    },
    getCountOfWidthBelow5() {
      let array = [this.simpleReusePercentage, this.creativePercentage, this.chemicalRecyclePercentage, this.materialRecyclePercentage,
            this.thermalRecyclePercentage, this.afterIncinerationRecyclePercentage, this.incinerationPercentage, this.landfillPercentage, this.recyclePercentage]
      let filtered = array.filter(function(value) {
        return (value > 0) && (value < 5)
      })
      return filtered.length
    },
    getCountOfWidth0(){
      let array = [this.simpleReusePercentage, this.creativePercentage, this.chemicalRecyclePercentage, this.materialRecyclePercentage,
             this.thermalRecyclePercentage, this.afterIncinerationRecyclePercentage, this.incinerationPercentage, this.landfillPercentage, this.recyclePercentage]
      let filtered = array.filter(function(value) {
        return value == 0
      })
      return filtered.length
    },
    adjustZeroPercentageWidth() {
      let array = [this.simpleReuseWidth, this.creativeWidth, this.recycleWidth, this.chemicalRecycleWidth, this.materialRecycleWidth,
             this.thermalRecycleWidth, this.afterIncinerationRecycleWidth, this.incinerationWidth, this.landfillWidth]
      let filtered = array.filter(function(value) {
        return value > 5
      })
      var countOfWidth0 = this.getCountOfWidth0()
      if (this.simpleReuseWidth > 5) {
        this.simpleReuseWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.creativeWidth > 5) {
        this.creativeWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.recycleWidth > 5) {
        this.recycleWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.chemicalRecycleWidth > 5) {
        this.chemicalRecycleWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.materialRecycleWidth > 5) {
        this.materialRecycleWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.thermalRecycleWidth > 5) {
        this.thermalRecycleWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.afterIncinerationRecycleWidth > 5) {
        this.afterIncinerationRecycleWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.incinerationWidth > 5) {
        this.incinerationWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.landfillWidth > 5) {
        this.landfillWidth += countOfWidth0 * 5 / filtered.length
      }
    },
    redrawChart() {
      let adjustedWidth = (100 - (this.getCountOfWidthBelow5() * 5)) / 100
      // 0%のものが混ざっていた場合の考慮を入れる
      this.adjustZeroPercentageWidth()
      if(adjustedWidth == 1) return

      if(this.simpleReuseWidth > 5) {
        this.simpleReuseWidth = this.simpleReuseWidth * adjustedWidth
      }

      if(this.creativeWidth > 5) {
        this.creativeWidth = this.creativeWidth * adjustedWidth
      }

      if(this.recycleWidth > 5) {
        this.recycleWidth = this.recycleWidth * adjustedWidth
      }

      if(this.chemicalRecycleWidth > 5) {
        this.chemicalRecycleWidth = this.chemicalRecycleWidth * adjustedWidth
      }

      if(this.materialRecycleWidth > 5) {
        this.materialRecycleWidth = this.materialRecycleWidth * adjustedWidth
      }

      if(this.thermalRecycleWidth > 5) {
        this.thermalRecycleWidth = this.thermalRecycleWidth * adjustedWidth
      }

      if(this.afterIncinerationRecycleWidth > 5) {
        this.afterIncinerationRecycleWidth = this.afterIncinerationRecycleWidth * adjustedWidth
      }

      if(this.incinerationWidth > 5) {
        this.incinerationWidth = this.incinerationWidth * adjustedWidth
      }

      if(this.landfillWidth > 5) {
        this.landfillWidth = this.landfillWidth * adjustedWidth
      }
    }
  }
}
</script>

<style scoped>
.bottom_container_total_chart {
  text-align: center;
}

.total_chart_value_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 56px;
  text-align: center;
  color: #343a3f;
}

.total_chart_graph {
  border-radius: 8px;
  display: grid;
  grid-template-rows: 2fr 4fr 1fr;
  box-sizing: border-box;
}

.base_container {
  width: 1408px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.19), 0 2px 2px rgba(0, 0, 0, 0.23);
  border-radius: 12px;
  margin-bottom: 30px;
  background-color: #ffffff;
}

.container_module_type {
  width: 100%;
}

.summary_grid {
  display: grid;
  grid-template-rows: 1fr 4fr;
  align-content: center;
}

.item_container_margin {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
}

.summary_top {
  display: grid;
  padding: 15px 15px;
  grid-template-columns: 1fr 1fr;
  border-bottom: solid 1px rgba(52, 58, 63, 0.1);
}

.summary_text {
  justify-content: center;
  flex-direction: column;
  display: flex;

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.15px;

  /* Forms/Normal */
  color: #333333;
}

.summary_text_weight_700 {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.15px;
}

.summary_menu_container {
  justify-content: center;
  flex-direction: column;
  display: flex;
  align-items: end;
}

.width_auto {
  width: auto;
}

.value_text_margin_standalone {
  margin-top: 20px;
  margin-bottom: 40px;
}

.value_text_margin_module {
  margin-top: 10px;
  margin-bottom: 30px;
}
</style>
